import RCC from '@/models/RoamingRCC';
import { getRequest, postRequest } from '@/api';
import { ROAMING_RCC_MUTATIONS } from '@/store/mutation-types';
import { sendAnalytics } from '@/helpers';

export const state = () => {
  return {
    rcc: new RCC(),
    rccLimit: 0,
    rccFetchPending: false,
    rccCommitPending: false,
    rccError: null,
    rccDirty: false,
  };
};

export const actions = {
  async fetchRCC({ commit }) {
    commit('setRCCFetchPending', true);
    const success = await getRequest('/rcc', ROAMING_RCC_MUTATIONS, commit);
    commit('setRCCFetchPending', false);
    return success;
  },
  async commitRCC({ commit, state }) {
    commit('setRCCCommitPending', true);
    const success = await postRequest(
      '/rcc',
      { limit: state.rccLimit },
      ROAMING_RCC_MUTATIONS,
      commit
    );
    commit('setRCCCommitPending', false);
    sendAnalytics('selection', 'roaming_limit', state.rccLimit);
    return success;
  },
  changeRCCLimit({ commit }, limit) {
    commit('changeLimit', limit);
  },
};

export const mutations = {
  [ROAMING_RCC_MUTATIONS.SUCCESS]: (state, rcc) => {
    state.rcc = new RCC(rcc);
    state.rccLimit = state.rcc.limit;
    state.rccDirty = false;
  },
  [ROAMING_RCC_MUTATIONS.PENDING]: () => undefined,
  [ROAMING_RCC_MUTATIONS.FAILURE]: (state, error) => (state.rccError = error),
  changeLimit: (state, limit) => {
    state.rccLimit = limit;
    state.rccDirty = true;
  },
  setRCCFetchPending: (state, pending) => (state.rccFetchPending = pending),
  setRCCCommitPending: (state, pending) => (state.rccCommitPending = pending),
};

export const getters = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
